import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { ItemViewModel } from 'src/app/viewmodels/ItemViewModel';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { SaveGCustomerRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-supplier-form',
  templateUrl: './supplier-form.component.html',
  styleUrls: ['./supplier-form.component.scss']
})
export class SupplierFormComponent implements OnInit {
  @Input() public vm: SaveGCustomerRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  private submitted = false;
  modalRefLv1: BsModalRef;
  public PhoneCodes: any = [];
  public tags: any = [];
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
     if (this.vm == undefined) {
      this.vm = new SaveGCustomerRequest();
      this._uow.gSettingService.LoadAccountFormAsync().subscribe((res: any) => {
        debugger
        this.vm.accCode = res.code;
      }, (err) => console.log(err));
    }
    if (this.modal_title == undefined) {
      this.modal_title = 'Supplier';
    }
    this.getTags();
    this.getPhoneCode();
  }
  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRefLv1 = this._modalService.show(template);
    }
  }
  getTags() {
    this._uow.gSettingService.GetTagsAsync().subscribe((res: any) => { this.tags = res.result; }, (err) => console.log(err));
  }

  getPhoneCode(){
    this._uow.gSettingService.GetCountryCodesAsync().subscribe((res: any) => { this.PhoneCodes = res.result; }, (err) => console.log(err));
  }
  saveOrUpdate() {
    // this._jq.showSpinner(true);
    this.spinner.show();
   this.vm.isCustomer = false;
   this.vm.cpCell = this.vm.countryCode +"-"+  this.vm.cpCell;
    this._uow.gSettingService
      .SaveGCustomerAsync(this.vm)
      .toPromise().then((res: any) => {
        console.log(res);
      // this._jq.showSpinner();
        this.submitted = true;
        this.bsmRef.hide();
        this.onSubmitted.emit(this.submitted);
        this.spinner.hide();
        Swal.fire(
          'Created!',
          'Created/Updated! Successfully',
          'success'
        )
      })
      .catch((error) => {
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(this.submitted);
      // this._jq.showSpinner();
      this.spinner.hide();
      });
  }

  onItemSubmitted(e) {
    if (e == true) {
      this.getTags();
    }
  }
   compareFn(optionOne, optionTwo): boolean {
    debugger
    if (optionOne !== undefined && optionTwo !== undefined) {
      return optionOne.id === optionTwo.id;
    }
  }

  // random unwanted fucks
  public toggleState = false;
  toggleVisbility() {
    this.toggleState = !this.toggleState;
  }

   closeModal() {
    this.bsmRef.hide();
    this.onSubmitted.emit(true); // Emit event to refresh list
  }
}
